import React, { useEffect, useState } from "react";
import dayjs from 'dayjs';
import ModalImage from "react-modal-image";
import { formatMoney } from "utils";

function Txn(props) {
  const { data } = props;
  let attachment = data?.get("attachment");
  const isPDF = attachment?.includes(".pdf");
  //TODO : If filename contains invalid characters, then change filename to valid filename
  const isImage = attachment?.match(/\.(jpg|jpeg|png|gif|webp)$/i);


  const normalView = () => {
    return (
      <div className="row pe-0">
        <div className="col-10 pe-md-5">
          <div className="row">
            <div className="col-4 pe-0" align="right" style={{ minWidth: "min-content" }}>
              <i className="fs-xmd-smaller text-nowrap">
                {formatMoney(Math.abs(data.get("amount")))}
              </i>
            </div>
            <div className="col-8 ms-auto">
              {data.get("detail")}
              {/* Attachments */}
              {(isImage || isPDF) && <div className="row">
                <div className="col-12">
                  {isPDF && (
                    <a className="text-decoration-none"
                      href={attachment}
                      target="_blank">
                      <i className="bi bi-file-pdf-fill text-app fs-1" />
                    </a>
                  )}

                  {isImage && (
                    <>
                      <ModalImage
                        small={attachment}
                        large={attachment}
                        hideDownload={true}
                        hideZoom={true}
                        alt={data.get("detail")}
                        className="uploadbillpreview"
                      />
                    </>
                  )}
                </div>
              </div>}
            </div>
          </div>
        </div>
        <div className="col-2 fs-xmd-smaller" align="right">
          <small><i>{dayjs(data.get("date")).format("DD MMM")}</i></small>
        </div>
      </div>
    )
  }

  return (
    <li className="list-group-item bg-transparent ">
      <div className="row">
        {!data.get("cancelled") && normalView()}
      </div>
    </li>
  )
}

export default Txn;
